<template>
  <div class="container">
    <van-nav-bar
      left-arrow
      left-text="首页"
      :fixed="true"
      @click-left="onClickLeft"
    >
      <template #right>
        <van-search v-model="searchvalue" show-action :clearable="false">
          <template #action>
            <div class="search-btn" @click="onSearch">搜索</div>
          </template>
        </van-search>
      </template>
    </van-nav-bar>
    <div class="divfixed">
      <van-dropdown-menu active-color="#ee0a24">
        <van-dropdown-item
          v-model="sortValue"
          :options="sort"
          @change="onChangeSort"
        />
        <van-dropdown-item
          v-model="couponType"
          :options="coupon"
          @change="onChangeCoupon"
        />
        <van-dropdown-item
          :title="categorieTitle"
          @open="onOpenfilter"
        ></van-dropdown-item>
      </van-dropdown-menu>
    </div>
    <div v-if="loadList">
      <div class="empty" v-if="list.length == 0">
        <van-empty
          class="custom-image"
          image="https://img.yzcdn.cn/vant/custom-empty-image.png"
        />
        <div class="nocontent">搜索不到相关内容</div>
        <div class="nocontent">试试别的关键词或筛选条件</div>
      </div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="content">
        <businesscard
          :object="item"
          v-for="(item, index) in list"
          :key="index"
          class="carditem"
        ></businesscard>
      </div>
    </van-list>
    <van-popup
      v-model="showfilter"
      position="right"
      :style="{ width: '90%', height: '99%', marginTop: divtop }"
    >
      <div class="contentpopup">
        <div class="popupdiv">
          <span
            class="categories"
            v-for="(filteritem, ind) in categories"
            @click="onClickGridItem(filteritem, ind)"
            :key="ind"
            :class="{ active: ind === s1 }"
            >{{ filteritem.name }}</span
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import searchstore from '@/api/searchstore.js'
import { productCategories, searchProduct } from '@/api/productsDetaile'
import Cookies from 'js-cookie'
import businesscard from '@/components/businesscard'
import { PRODUCT_ENQUIRY } from '@/config/platformtype'
import getCurrentPosition from '@/mixins/getCurrentPosition'

export default {
  name: 'puhui',
  components: {
    businesscard,
  },
  mixins: [getCurrentPosition],
  data() {
    return {
      categorieTitle: '更多',
      loadList: false,
      lat: 0,
      lon: 0,
      loading: false,
      finished: false,
      params: {
        current: 1,
        platformType: PRODUCT_ENQUIRY,
        size: 10,
        sortType: 'Sales',
        couponTypes: [],
      },
      s1: '',
      keyword: '',
      list: [],
      categories: [],
      divtop: '98px',
      showfilter: false,
      searchvalue: '',
      sortValue: 'Sales',
      couponType: '',
      sort: [
        {
          text: '离我最近',
          value: 'NearestToMe',
        },

        {
          text: '销售次数',
          value: 'Sales',
        },
      ],
      coupon: [
        {
          text: '全部类型',
          value: '',
        },
        {
          text: '官方福利券',
          value: 6,
        },
        {
          text: '单位福利券',
          value: 'danwei',
        },
        {
          text: '商家优惠券',
          value: 'shangjia',
        },
      ],
    }
  },
  mounted() {
    if (this.$getIsApp()) {
      this.$callApp('Android', 'HiddenTabBarMethod', '')
      this.$callApp('iOS', 'HiddenTabBarMethod', '')
    }
    this.getProductCategories()
  },
  methods: {
    onLoad() {
      searchProduct(this.params).then((res) => {
        if (res.data.code === 200) {
          this.loadList = true
          // 加载状态结束
          this.loading = false
          this.list = this.list.concat(res.data.data.records)
          console.log('产品列表this.list', this.list)
          this.totalCount = res.data.data.total
          this.params.current++
          // 数据全部加载完成
          if (
            res.data.data.records < 10 ||
            this.list.length === this.totalCount
          ) {
            this.finished = true
            console.log('loade结束')
          }
        }
      })
    },
    onClickGridItem(item, ind) {
      console.log('分类', item)
      if (item.id == 0) {
        delete this.params.topCategoryId
        this.params.current = 1
        this.params.size = 10
        this.list = []
        this.onLoad()
      } else {
        this.params.current = 1
        this.params.size = 10
        this.params.topCategoryId = item.id
        this.list = []
        this.onLoad()
      }
      this.s1 = ind
      this.categorieTitle = item.name
      this.showfilter = false
    },
    onClickLeft() {
      console.log('1111111111111111111');
      if (this.$route.query.isback) {
        this.$callApp('Android', 'GoHomePageMethod', '')
        this.$callApp('iOS', 'GoHomePageMethod', '')
      } else {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      }
    },

    onOpenfilter() {
      console.log('test')
      this.showfilter = !this.showfilter
    },
    onChangeCoupon(value) {
      if (value == 'danwei') {
        this.params.current = 1
        this.params.size = 10
        this.params.couponTypes = [4, 5]
        this.list = []
        this.onLoad()
      }
      if (value == 'shangjia') {
        this.params.current = 1
        this.params.size = 10
        this.params.couponTypes = [0, 1, 2, 3, 7, 8]
        this.list = []
        this.onLoad()
      }
      if (value == 6) {
        this.params.current = 1
        this.params.size = 10
        this.params.couponTypes = [6]
        this.list = []
        this.onLoad()
      }
      if (value == '') {
        this.params.current = 1
        this.params.size = 10
        delete this.params.couponTypes
        this.list = []
        this.onLoad()
      }
      this.coupon.forEach((el) => {
        if (value === '') {
          this.munetitle = '券类型'
          return
        } else {
          if (el.value === value) {
            this.munetitle = el.text.substr(0, 5)
            return
          }
        }
      })
    },
    onChangeSort(val) {
      console.log('111111111', val)
      if (val === 'NearestToMe') {
        this.params.sortType = 'NearestToMe'
        this.params.current = 1
        this.params.size = 10
        if (this.lon) {
          this.params.lon = this.lon
          this.params.lat = this.lat
        } else {
          this.params.lon = 0
          this.params.lat = 0
        }
        this.list = []
        this.onLoad()
      }
      if (val === 'Sales') {
        delete this.params.lon
        delete this.params.lat
        this.params.sortType = 'Sales'
        this.params.current = 1
        this.params.size = 10
        this.list = []
        this.onLoad()
      }
    },
    onSearch() {
      if (this.searchvalue === '') {
        if (this.params.keyword) {
          delete this.params.keyword
        }
        this.params.current = 1
        this.params.size = 10
        this.list = []
        this.onLoad()
      }
      if (this.searchvalue !== '') {
        this.params.keyword = this.searchvalue
        this.params.current = 1
        this.params.size = 10
        this.list = []
        this.onLoad()
      }
    },
    getProductCategories() {
      productCategories().then((res) => {
        this.categories = res.data.data
        this.categories.unshift({ id: 0, name: '全部' })
      })
    },
    /**
     * 定位成功
     */
    onLocateSuccess(position) {
      this.lon = position.longitude
      this.lat = position.latitude
    },

    /**
     * 定位失败
     */
    onLocateFailed(error) {
      // this.$dialog.alert({
      //   title: '无法获取当前位置',
      //   message: error.message,
      // })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.active {
  background-color: #f44d4d;
  color: #fff;
}
.container {
  background-color: #efefef;
  min-height: 100vh;
}
.search-btn {
  font-size: 15px;
}
.nocontent {
  text-align: center;
  width: 360px;
  color: #666;
  font-size: 12px;
  margin-left: 7px;
}

/deep/ .van-nav-bar .van-icon {
  color: black;
  font-size: 17px;
}

/deep/.van-grid-item__text {
  font-size: 15px;
}

.van-nav-bar {
  line-height: 50px;
  height: 50px;
  /deep/.van-nav-bar__text {
    font-size: 15px;
    color: black;
  }
  .van-nav-bar__arrow {
    font-size: 18px;
  }
}

.van-icon-success::before {
  font-size: 15px;
}
/deep/ .van-nav-bar__right{
  padding: 0 5px 0 0;
}
/deep/ .van-search {
  line-height: 50px;
  height: 50px;
  margin-left: 30px;
  font-size: 16px;

  .van-search__content {
    border-radius: 20px;
    padding-left:5px;
  }
}
/deep/ .van-nav-bar__title {
  max-width: 100%;
}
.popupdiv {
  padding: 10vw 3vw;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .categories {
    text-align: center;
    width: 90px;
    border: 1px solid #e9e9e9;
    padding: 10px 5px;
    margin: 5px 3px 5px 0px;
  }
}

.contentpopup {
  padding: 1vw 0vw 20vw 0vw;
}
.divfixed {
  position: fixed;
  width: 100%;
  top: 50px;
  height: 25px;
  z-index: 100;
}

.content {
  margin-top: 88px;
  text-align: center;
  bottom: 2.5px;
  padding: 10px 0;
}

/deep/.van-dropdown-menu {
  height: 20px;
  font-size: 16px;
  position: static;
}

/deep/.van-cell__title {
  font-size: 15px;
  padding: 5px 0px;
}

/deep/.van-dropdown-menu__title::after {
  top: 35%;
  right: -10px;
  width: 4px;
  height: 4px;
}

/deep/.van-ellipsis {
  line-height: 20px;
  font-size: 15px;
}
/deep/ .custom-image .van-empty__image {
  width: 100px;
  height: 100px;
}
.empty {
  padding-top: 190px;
}
</style>
